/* Vendor_mediaGET_VENDOR_MEDIA */
export const GET_VENDOR_MEDIA = "GET_VENDOR_MEDIA"
export const GET_VENDOR_MEDIA_SUCCESS = "GET_VENDOR_MEDIA_SUCCESS"
export const GET_VENDOR_MEDIA_FAIL = "GET_VENDOR_MEDIA_FAIL"

/* Vendor_mediaGET_VENDOR_MEDIA PROFILE */
export const GET_VENDOR_MEDIA_PROFILE = "GET_VENDOR_MEDIA_PROFILE"
export const GET_VENDOR_MEDIA_PROFILE_SUCCESS = "GET_VENDOR_MEDIA_PROFILE_SUCCESS"
export const GET_VENDOR_MEDIA_PROFILE_FAIL = "GET_VENDOR_MEDIA_PROFILE_FAIL"

/**
 * add VENDOR_MEDIA
 */
 export const ADD_NEW_VENDOR_MEDIA = "ADD_NEW_VENDOR_MEDIA"
 export const ADD_VENDOR_MEDIA_SUCCESS = "ADD_VENDOR_MEDIA_SUCCESS"
 export const ADD_VENDOR_MEDIA_FAIL = "ADD_VENDOR_MEDIA_FAIL"

 /**
 * Edit VENDOR_MEDIA
 */
export const UPDATE_VENDOR_MEDIA = "UPDATE_VENDOR_MEDIA"
export const UPDATE_VENDOR_MEDIA_SUCCESS = "UPDATE_VENDOR_MEDIA_SUCCESS"
export const UPDATE_VENDOR_MEDIA_FAIL = "UPDATE_VENDOR_MEDIA_FAIL"

/**
 * Delete VENDOR_MEDIA
 */
export const DELETE_VENDOR_MEDIA = "DELETE_VENDOR_MEDIA"
export const DELETE_VENDOR_MEDIA_SUCCESS = "DELETE_VENDOR_MEDIA_SUCCESS"
export const DELETE_VENDOR_MEDIA_FAIL = "DELETE_VENDOR_MEDIA_FAIL"


